"use client";

import Image from "next/image";
import { useState } from "react";
import { QrCodePopover } from "./QrCodePopover";

export function SupportWechatQrCode() {
  return <Image src="/images/social/support-wechat.png" alt="客服微信二维码" width={1156} height={1174} unoptimized className="h-auto w-full" />;
}

export function SupportContact({ className, label = "客服与订单帮助", side = "top" }: { className?: string; label?: string; side?: "top" | "bottom" }) {
  return <QrCodePopover label={label} className={className} side={side}>
    <SupportWechatQrCode />
  </QrCodePopover>;
}

export function CopyContact({ value, label, inline = false }: { value: string; label: string; inline?: boolean }) {
  const [status, setStatus] = useState<"idle" | "copied" | "error">("idle");

  async function copy() {
    try {
      await navigator.clipboard.writeText(value);
      setStatus("copied");
    } catch {
      setStatus("error");
    }
  }

  if (inline) return <>
    <button type="button" onClick={copy} aria-label={`复制${label}：${value}`}
      className="select-all break-all text-left underline-offset-4 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-accent)]">{value}</button>
    <span role="status" className="sr-only">{status === "copied" ? `${label}已复制` : status === "error" ? "复制失败，请选中文字复制" : ""}</span>
  </>;

  return <div className="shrink-0 text-right">
    <button type="button" onClick={copy} aria-label={`复制${label}`}
      className="min-h-11 min-w-16 rounded-lg px-2 text-sm text-[var(--color-muted)] hover:text-[var(--color-paper)] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-accent)]">
      {status === "copied" ? "已复制" : "复制"}
    </button>
    <span role="status" className={status === "error" ? "block max-w-24 text-xs text-[var(--color-muted)]" : "sr-only"}>
      {status === "copied" ? `${label}已复制` : status === "error" ? "复制失败，请长按或选中文字复制" : ""}
    </span>
  </div>;
}
